import React, { useRef } from "react"
import { navigate } from "gatsby"
import { Box } from "@rebass/grid/emotion"
import gsap from "gsap"
import { useGSAP } from "@gsap/react"

import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

import { StatFlex, RightBox } from "./stats.styled"

const START_DISTANCE = 20 // start counting from the value - 20

const ScrollStat = ({ stat, statsLength, statWidth = [], i, moduleName }) => {
  const statRef = useRef(null)

  useGSAP(() => {
    const statNumber = statRef.current.querySelector(".stat-value")

    if (!statNumber) {
      return
    }

    const targetNumber = parseFloat(stat.number)

    gsap.fromTo(
      statNumber,
      {
        textContent: Math.max(0, stat.number - START_DISTANCE),
      },
      {
        textContent: stat.number,
        duration: 2.5,
        ease: "power2.out",
        snap: { statNumber: 1 },
        onUpdate: function () {
          const currentValue = parseFloat(statNumber.textContent)
          statNumber.innerHTML = Number.isInteger(targetNumber)
            ? Math.ceil(currentValue).toLocaleString() // Integer: Round up
            : currentValue.toFixed(1).toLocaleString() // Float: Show 1 decimal
        },
        scrollTrigger: {
          trigger: statRef.current,
          start: "top bottom",
          // markers: true,
        },
      }
    )
  }, [])

  const handleLinkClick = () => {
    segmentEvent("Marketing CTA Clicked", {
      text: stat.link.text,
      type: "button",
      module_location: "mid_fold",
      module_name: moduleName,
      destination: stat.link.destination,
    })
    navigate(stat.link.destination)
  }

  return (
    <StatFlex
      flexWrap="wrap"
      alignItems={stat?.link ? "flex-start" : "center"}
      key={i}
      py={[16, null, 16, 24]}
      pl={[8, null, 16, 24]}
      pr={[8, null, 8, 24]}
      className={`${i === 0 ? "first" : i === statsLength - 1 ? "last" : ""}`}
      ref={statRef}
    >
      <Box width={statWidth}>
        <TextElementNova
          text={`<span class='stat-value font-grilliBook'>${
            stat.number
          }</span>${
            stat.suffix
              ? `<span class='font-grilliBook'>${stat.suffix}</span>`
              : ""
          }`}
          element="h3"
          classes={
            stat?.numberClasses || {
              default: "Title-30-Super-Normal",
              768: "Title-20-Super-Normal",
              1024: "Title-30-Super-Normal",
            }
          }
          className="text-nova-base-white stat-value-box"
        />
      </Box>
      <RightBox
        className={stat?.link ? "include-link" : ""}
        pl={[16, null, null, 24]}
      >
        <TextElementNova
          text={stat.copy}
          element="p"
          classes={
            stat?.copyClasses || {
              default: "Body-20-Dia-Normal",
            }
          }
          className="text-nova-base-white pr-4"
        />
        {stat.link ? (
          <Box className="button-wrapper" mt={[8, null, null, 0, 21]}>
            <ButtonNova
              icon={"Right"}
              level={"Textlink"}
              label={stat.link.text}
              onClick={handleLinkClick}
            />
          </Box>
        ) : null}
      </RightBox>
    </StatFlex>
  )
}

export default ScrollStat
